<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
      clearable
      @on-clear='clear'
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="250"
      draggable
      class="my-drawer"
    >
      <group-tree isMore @groups="reGroups" @group="reGroup" :noAutoLoad='noAutoLoad'></group-tree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["placement","noAutoLoad"],
  data() {
    return {
      openGroup: false,
      name: "",
      groupIdList: [],
    };
  },
  methods: {
    reGroups(v) {
      var t = [];
      this.groupIdList = [];
      for (let i = 0; i < v.length; i++) {
        t.push(v[i].name);
        this.groupIdList.push(v[i].id);
      }
      if (t.length <= 2) {
        this.name = t.join(",");
      } else {
        this.name = t[0] + "等" + t.length + "个单位";
      }
      this.$emit("groupIdList", this.groupIdList);
      this.$emit("name", this.name);
    },
    reGroup(v){
        this.groupIdList=[v.id];
        this.name=v.name;
        this.$emit("groupIdList", this.groupIdList);
        this.$emit("name", this.name);
    },
    clear(){
        this.groupIdList=[];
        this.$emit("groupIdList", this.groupIdList);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectAlotGroup.vue